import React, { useState, useRef } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import emailjs from '@emailjs/browser';

const FormContactEn = () => {

    const [name, setName] = useState('');
    const [city, setCity] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [phone, setPhone] = useState('');
    const [commentOn, setCommentOn] = useState('- Select -');
    const [commentDetails, setCommentDetails] = useState('');
    const [messageSent, setMessageSent] = useState();
    const [messageError, setMessageError] = useState();
    const [captchaValue, setCaptchaValue] = useState(null);
    const captchaKey = process.env.REACT_APP_RECAPTCHA_KEY;
    const isEmail = (email) => /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email);
        
    const renderTextField = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_text'>
                    <input name={inputData.name}
                        id={inputData.id}
                        type={inputData.type}
                        value={value}
                        className='medium'
                        aria-invalid="false"
                        aria-required={inputData.ariaRequired}
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)}>
                    </input>
                    {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
                </div>
            </>
        );
    }

    const renderTextArea = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_textarea'>
                    <textarea name={inputData.name}
                        id={inputData.id}
                        className='textarea medium'
                        value={value}
                        aria-invalid="false" rows='10' cols='50'
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)} />
                    {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
                </div>
            </>
        );
    }


    const renderPhoneField = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_email'>
                    <input
                        name={inputData.name}
                        id={inputData.id}
                        type={inputData.type}
                        value={value}
                        className='medium'
                        aria-required="true" aria-invalid="false"
                        aria-describedby={inputData.description}
                        onChange={(e) => onChange(e.target.value)}>
                    </input>
                    {inputData.message ? <p className='hidden' id={inputData.description}>{inputData.message}</p> : ""}
                </div>
            </>
        );
    }

    const renderEmailField = (inputData, value, onChange) => {
        return(
            <>
            <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
            <div className='input_container input_container_email'>
                <input 
                name={inputData.name} 
                id={inputData.id} 
                type='email' 
                value={value} 
                className='medium' 
                aria-required="true" aria-invalid="false" aria-describedby="field_description_email"
                onChange={(e) => onChange(e.target.value)}>
                </input>
            </div>
            <div className={`sp_field_description ${isEmail(value) ? "" : "invalid"}`} id="field_description_email">{!isEmail(value) ? inputData.description : "Thank You"}</div>
            </>
        );
    }

    const renderDropdown = (inputData, value, onChange) => {
        return (
            <>
                <label className='field_label' htmlFor={inputData.id}>{inputData.label}{inputData.required ? <span className='field_required'>*</span> : ""}</label>
                <div className='input_container input_container_select'>
                    <select
                        name={inputData.name}
                        id={inputData.id}
                        className='medium field_select'
                        aria-required="true"
                        aria-invalid="false"
                        value={value}
                        onChange={(e) => onChange(e.target.value)}
                    >
                        {inputData.option.map(({ value, label }, i) => <option key={`${inputData.name}-${i}`} value={value}>{label}</option>)}
                    </select>
                </div>
            </>
        )
    }

    const renderName = () => {
        const inputData = {
            name: 'Your name',
            id: 'name',
            label: 'Name',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_name',
            message: 'Your name is required.'
        }
        return renderTextField(inputData, name, setName);
    }

    const renderCity = () => {
        const inputData = {
            name: 'your city',
            id: 'location',
            label: 'Your City',
            type: 'text',
            value: '',
            required: true,
            ariaRequired: 'true',
            description: 'field_description_city',
            message: 'Your location is required.'
        }
        return renderTextField(inputData, city, setCity);
    }

    const renderEmailDetails = () => {
        const inputData = {
            name: 'your email',
            id: 'emailAddress',
            label: 'Email',
            type: 'email',
            required: true,
            description: 'Please provide a valid email address.',
        }
        return renderEmailField(inputData, emailAddress, setEmailAddress);
    }

    const renderPhoneDetails = () => {
        const inputData = {
            name: 'phone number',
            label: 'Phone',
            id: 'phoneNumber',
            type: 'tel',
            required: false,
            description: 'field_description_phone',
            message: 'Your phone number is optional.'
        }
        return renderPhoneField(inputData, phone, setPhone);
    }

    const renderCommentChoices = () => {
        const inputData = {
            id: 'commentChoice',
            name: 'Comment on',
            label: 'Comment on',
            option: [
                { label: '- Select -', value: 'Select' },
                { label: 'General', value: 'General' },
                { label: 'Website', value: 'Website' },
                { label: 'Video Archives', value: 'Video Archives' },
                { label: 'CPAC Programs', value: 'CPAC Programs' },
                { label: 'Careers', value: 'Careers' },
                { label: 'CPAC in Your Area', value: 'CPAC in Your Area' },
                { label: 'Order a Video', value: 'Order a Video' },
                { label: 'Social Media', value: 'Social Media' },
            ],
            required: true,
        };

        return renderDropdown(inputData, commentOn, setCommentOn);
    }

    const renderComments = () => {
        const inputData = {
            name: 'your comments',
            id: 'comments',
            label: 'Comments',
            description: 'field_description_comments',
            message: 'Please provide any comments or questions.',
            required: true,
        }
        return renderTextArea(inputData, commentDetails, setCommentDetails);
    }
    const captchaRef = useRef(null);
    
    const onReCaptchaChange = (value) => {
        setCaptchaValue(value);
    }

    const buttonDisabled = (captchaValue) => {
        return (
            !captchaValue ? "disabled" : ""
        )
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        captchaRef.current.reset();

        const templateParams = {
            senderLanguage: "English",
            senderName: name, 
            senderCity: city, 
            senderEmail: emailAddress ? emailAddress : "webform@cpac.ca", 
            senderPhone: phone, 
            senderTopic: commentOn, 
            senderComments: commentDetails
        };
        emailjs.send('outlook_service', 'contact_form_template', templateParams, process.env.REACT_APP_EMAILJS_KEY)
                    .then(function() {
                        setMessageSent(true);
                        e.target.reset(); // reset the form
                    }, function(error) {
                        setMessageError(true);
                    });
    }
    
    return (
        <>
        {
            messageSent ? <h2 className='form_wrapper message_success'>Thank you for your submission.</h2> : messageError ? <h2 className='form_wrapper message_fail'>Sorry there was a problem with your submission. Please try again later.</h2> : 
            <div id="form_wrapper" className="form_wrapper" itemScope itemType="https://schema.org/ContactPage">
                <form id="contact-form" onSubmit={(e) => handleSubmit(e)} itemScope itemType="https://schema.org/WebPageElement">
                    <div className="form_body" itemProp='mainEntityOfPage'>
                        {renderName()}
                        {renderCity()}
                        {renderEmailDetails()}
                        {renderPhoneDetails()}
                        {renderCommentChoices()}
                        {renderComments()}
                    </div>
                    <ReCAPTCHA sitekey={captchaKey} ref={captchaRef} onChange={onReCaptchaChange} />
                    <div className='form_footer left_label'>
                        <button type="submit" className="btn--primary" disabled={buttonDisabled(captchaValue)}>Submit</button>
                    </div>
                </form>
            </div>
        }
        </>
    )
}

export default FormContactEn;